import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><path d=\"M670.955 937.173L269.44 535.637a32 32 0 01-2.09-42.965l2.09-2.283L670.933 88.832a8.533 8.533 0 016.038-2.496h66.368a8.533 8.533 0 016.037 14.57L337.28 512.982 749.397 925.1a8.533 8.533 0 01-6.037 14.57h-66.347a8.533 8.533 0 01-6.058-2.496z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol